module.exports = __webpack_public_path__ + "img/ic-download.eb03a07f.svg";